import CardOrderFull from './CardOrderFull';

export default CardOrderFull;
